/**
 * Handle dependency loading mainly related to dynamic page templates.
 */

import path from 'path';

const templatePath = path.resolve('client/templates');

/**
 * Load appropriate templates for the provided name.
 *
 * @param {string} name template name (originally page content)
 */
export const requireTemplateByName = (name) => {
  let Component = null;

  try {
    // eslint-disable-next-line import/no-dynamic-require, global-require
    Component = require(`templates/${name}/${name}.js`).default;
  } catch (_e) {
    // eslint-disable-next-line no-throw-literal
    throw `Could not create a component with the name '${name}'. Tried searching:
        ${templatePath}/${name}/${name}.js'.`;
  }

  if (!Component) {
    // eslint-disable-next-line no-throw-literal
    throw `Could not find a component with the name '${name}'. Tried searching:
        ${templatePath}/${name}/${name}.js'.`;
  }

  return Component;
};

/**
 * Load appropriate graphql query for the provided name.
 *
 * @param {string} name template name (originally page content)
 */
export const requireQueryByName = (name) => {
  let query = null;

  try {
    // eslint-disable-next-line import/no-dynamic-require, global-require
    query = require(`templates/${name}/${name}.query.js`).default;
  } catch (_e) {
    // Add logger here
    // eslint-disable-next-line no-throw-literal
    throw `Something went wrong when executing a query with the name ${name}.query.js. Tried searching:
        ${templatePath}/${name}/${name}.query.js'`;
  }

  if (!query) {
    // eslint-disable-next-line no-throw-literal
    throw `Could not find a query with the name '${name}'.query.js. Tried searching:
        ${templatePath}/${name}/${name}.query.js'`;
  }

  return query;
};
